import React, { Component } from 'react';
import { MediaQueryProvider } from '../Frame/MediaQueryProvider.js';
import { DocumentContext } from '../hooks/useDocument.js';
import { ScrollLockManagerContext } from '../ScrollLock/useScrollLockManager.js';
import { ToastContainer } from '../Toast/ToastContainer.js';
import { FocusManager } from '../TrapFocus/FocusManager.js';
import { ScrollLockManager } from '../utils/scroll-lock-manager.js';
import { UniqueIdFactory, UniqueIdFactoryContext, globalIdGeneratorFactory, } from '../utils/unique-id.js';
export class AppProvider extends Component {
    constructor(props) {
        super(props);
        this.uniqueIdFactory = new UniqueIdFactory(globalIdGeneratorFactory);
        this.scrollLockManager = new ScrollLockManager();
    }
    render() {
        const { children } = this.props;
        const document = typeof window === 'undefined' ? null : window.document;
        return (React.createElement(ScrollLockManagerContext.Provider, { value: this.scrollLockManager },
            React.createElement(UniqueIdFactoryContext.Provider, { value: this.uniqueIdFactory },
                React.createElement(DocumentContext.Provider, { value: { document } },
                    React.createElement(MediaQueryProvider, null,
                        React.createElement(FocusManager, null,
                            children,
                            React.createElement(ToastContainer, null)))))));
    }
}
//# sourceMappingURL=AppProvider.js.map